import { SelectorOption } from "./GenerateSelectorOptions";

export interface SearchState {
  query: string;
  verse: string;
  isLoading: boolean;
  isSuggestionsOpen: boolean;
  isHistoryOpen: boolean;
  options: SelectorOption[];
  isQueryComplete: boolean;
  isAtMaxChapter: boolean;
  searchHistory: string[];
  fetchedAsComplete: boolean;
}

export const initialSearchState: SearchState = {
  query: "",
  verse: "",
  isLoading: false,
  isSuggestionsOpen: false,
  isHistoryOpen: false,
  options: [],
  isQueryComplete: false,
  isAtMaxChapter: false,
  searchHistory: [],
  fetchedAsComplete: false,
};

export type SearchAction =
  | {
      type: "INPUT_CHANGE";
      query: string;
      options: SelectorOption[];
      isSuggestionsOpen: boolean;
      isHistoryOpen: boolean;
      isQueryComplete: boolean;
    }
  | { type: "FETCH_START"; isQueryComplete: boolean; isAtMaxChapter: boolean }
  | { type: "FETCH_SUCCESS"; query: string; verse: string; searchHistory: string[]; fetchedAsComplete: boolean }
  | { type: "SET_VERSE"; verse: string }
  | { type: "SET_QUERY"; query: string }
  | { type: "RESET" }
  | { type: "SET_SUGGESTIONS_OPEN"; value: boolean }
  | { type: "SET_HISTORY_OPEN"; value: boolean };

export function searchReducer(state: SearchState, action: SearchAction): SearchState {
  switch (action.type) {
    case "INPUT_CHANGE":
      return {
        ...state,
        query: action.query,
        options: action.options,
        isSuggestionsOpen: action.isSuggestionsOpen,
        isHistoryOpen: action.isHistoryOpen,
        isQueryComplete: action.isQueryComplete,
      };
    case "FETCH_START":
      return {
        ...state,
        isLoading: true,
        isQueryComplete: action.isQueryComplete,
        isAtMaxChapter: action.isAtMaxChapter,
      };
    case "FETCH_SUCCESS":
      return {
        ...state,
        isLoading: false,
        isSuggestionsOpen: false,
        query: action.query,
        verse: action.verse,
        searchHistory: action.searchHistory,
        fetchedAsComplete: action.fetchedAsComplete,
      };
    case "SET_VERSE":
      return { ...state, verse: action.verse };
    case "SET_QUERY":
      return { ...state, query: action.query };
    case "RESET":
      return { ...state, query: "", verse: "", fetchedAsComplete: false };
    case "SET_SUGGESTIONS_OPEN":
      return { ...state, isSuggestionsOpen: action.value };
    case "SET_HISTORY_OPEN":
      return { ...state, isHistoryOpen: action.value };
    default:
      return state;
  }
}
